import React, { createContext, useContext, useState, ReactNode } from "react";

interface TitleContextProps {
  title: string;
  subtitle: string;
  setTitle: (title: string) => void;
  setSubtitle: (subtitle: string) => void;
}

const TitleContext = createContext<TitleContextProps>({
  title: "Default Title",
  subtitle: "Default Subtitle",
  setTitle: () => {},
  setSubtitle: () => {},
});

export const useTitle = () => useContext(TitleContext);

export const TitleProvider = ({ children }: { children: ReactNode }) => {
  const [title, setTitleState] = useState("");
  const [subtitle, setSubtitleState] = useState("");

  const setTitle = (newTitle: string) => {
    setTitleState(newTitle);
  };

  const setSubtitle = (newSubtitle: string) => {
    setSubtitleState(newSubtitle);
  };

  return (
    <TitleContext.Provider value={{ title, subtitle, setTitle, setSubtitle }}>
      {children}
    </TitleContext.Provider>
  );
};
